// extracted by mini-css-extract-plugin
module.exports = {"banner":"ProfileBanner_banner__2rovj","image":"ProfileBanner_image__2zwis","editIcon":"ProfileBanner_editIcon__3my24"};